import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { PermissionService } from '../../../core/services/permission.service';
import * as authActions from '../actions/validate-token.actions';
import { IValidateTokenRequest, IValidateTokenResponse } from '../models/validate-token.model';
import { SessionStorageIds } from '../../../shared/enums';

@Injectable()
export class ValidateTokenEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helperService: HelpersService,
    private permissionService: PermissionService
  ) {}

  validateToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.loadValidateToken),
      switchMap(action =>
        this.networkCallService
          .post<IValidateTokenRequest, IValidateTokenResponse>('Authentication/validateToken', action.request)
          .pipe(
            map(response => {
              sessionStorage.setItem(SessionStorageIds.AUTH_PERMISSIONS, JSON.stringify(response.permissions || []));
              sessionStorage.setItem(SessionStorageIds.AUTH_ROLES, JSON.stringify(response.roles || []));
              sessionStorage.setItem(
                SessionStorageIds.AUTH_LEGAL_ENTITY_PERMISSIONS,
                JSON.stringify(response.legalEntityPermissions || [])
              );
              if (response.currentLegalEntityId) {
                sessionStorage.setItem(SessionStorageIds.AUTH_CURRENT_LEGAL_ENTITY_ID, response.currentLegalEntityId);
              }

              this.permissionService.refreshFromSession();
              return authActions.loadValidateTokenSuccess({ response });
            }),
            catchError(error => {
              return of(authActions.loadValidateTokenFailure({ error }));
            })
          )
      )
    )
  );
}
